import React from "react"

import {
  TYPE_SSN,
  TYPE_DATE,
  TYPE_OBJECT,
} from "@components/Form"
import validateDob from "@helpers/validateDob"
import { MarkdownAlert } from "@components/Markdown"
import getUsAddressSchema from "@helpers/getUsAddressSchema"

const LABEL_SSN = "Social Security Number"
const LABEL_DOB = "Date of Birth"
const LABEL_ADDRESS = "Physical Address"
const LABEL_LAST_NAME = "Legal Last Name"
const LABEL_FIRST_NAME = "Legal First Name"

const LABEL_RETRY = `Identity verification has failed.

Please ensure the accuracy of the submitted information and click "Continue".`


const getInputs = (isRetry) => {
  const retryInput = {
    name: "_retry",
    component: () =>
      <MarkdownAlert
        type="warning"
        text={LABEL_RETRY}
      />
  }

  const inputs = isRetry
    ? [ retryInput ]
    : []

  inputs.push(
    {
      name: "personalCustomer",
      type: TYPE_OBJECT,
      label: "",
      schema: [
        {
          name: "firstName",
          label: LABEL_FIRST_NAME,
          required: true,
          maxLength: 50,
        },
        {
          name: "lastName",
          label: LABEL_LAST_NAME,
          required: true,
          maxLength: 50,
        },
        {
          name: "dateOfBirth",
          type: TYPE_DATE,
          label: LABEL_DOB,
          required: true,
          itemProps: {
            rules: [validateDob()]
          }
        },
        {
          name: "ssn",
          type: TYPE_SSN,
          label: LABEL_SSN,
          required: true,
        },
        {
          name: "address",
          type: TYPE_OBJECT,
          label: LABEL_ADDRESS,
          schema: getUsAddressSchema(),
        }
      ]
    },
  )

  return inputs
}

export default getInputs
